import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Tooltip } from 'reactstrap';
import * as types from "../../constants/actionTypes";
import GenericInput from "../common/input/GenericInput";
import SectionLoadingError from '../common/SectionLoadingError';
import DataComponent from "../common/DataComponent";
import * as Tools from "../../helpers/Tools";
import MiniSpinner from "../common/MiniSpinner";
import { logUI } from '../../api/andyliticsApi';
import ConfirmationModal from '../common/ConfirmationModal';


export const initialState = {
    editingPassword: false,
    oldPassword: "",
    newPassword: "",
    newPasswordConfirmation: "",
    tooltipOpen: false,
    errors: {
        hasCapital: false,
        hasLower: false,
        hasSpecial: false,
        hasReqLength: false,
        passwordMismatch: false,
        newPasswordEmpty: true,
        oldPasswordEmpty: true,
        passwordConfirmationEmpty: true
    },
};

class LoginSettingsUserName extends DataComponent {

    constructor(props) {
        super(props);

        this.state = initialState;

        this.toggleEdit = this.toggleEdit.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.save = this.save.bind(this);
        this.savePassword = this.savePassword.bind(this);
        this.handlePasswordInputChange = this.handlePasswordInputChange.bind(this);
        this.closeEdit = this.closeEdit.bind(this);
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.LoginSettingsUserName.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        const { clearPasswordChangeState } = this.props;
        clearPasswordChangeState();
    }


    toggleEdit() {
        const { editingPassword } = this.state;
        const { clearPasswordChangeState, passwordUpdateError } = this.props;
        if (editingPassword && passwordUpdateError) {
            clearPasswordChangeState();
        }
        this.setState({ editingPassword: !editingPassword });

    }

    save() {
        let { newName, newNameConfirmation, errors } = this.state;
        const { changeUserName, userName } = this.props;
        if (!errors.userNameMismatch && !errors.userNameEmpty && !errors.userNameConfirmationEmpty) {
            changeUserName(userName, newName, this.closeEdit);
        }
    }

    savePassword = () => {
        const { changePassword, isLoggedIn, userName } = this.props;
        const { oldPassword, newPassword, newPasswordConfirmation } = this.state;
        if (isLoggedIn) {
            logUI("MBHWeb.Login.Password.Change", new Date(), Tools.getURLPath());
            changePassword(userName, oldPassword, newPassword, newPasswordConfirmation, this.closeEdit);   //pass all password data   

        }
        //this.togglePassword();
    }



    handlePasswordInputChange(event) {
        const target = event.target;
        const value = !target ? event : target.type === 'checkbox' ? target.checked : target.value;
        let { errors, oldPassword, newPassword, newPasswordConfirmation } = this.state;

        if (target.name === 'OldPassword') {
            oldPassword = value;
        }
        else if (target.name === 'NewPassword') {
            newPassword = value;
        } else if (target.name === 'ConfirmPassword') {
            newPasswordConfirmation = value;
        }

        errors.hasCapital = (/([A-Z]+)/g.test(newPassword)) ? true : false;
        errors.hasLower = (/([a-z]+)/g.test(newPassword)) ? true : false;
        errors.hasSpecial = (/[!@#$ %^&* (),.? ":{}|<>/[`~|\]\\0-9]/g.test(newPassword)) ? true : false;
        errors.hasReqLength = newPassword.length > 7 ? true : false;
        errors.passwordConfirmationEmpty = newPasswordConfirmation.length < 1;
        errors.oldPasswordEmpty = oldPassword.length < 1;
        errors.newPasswordEmpty = newPassword.length < 1;
        errors.passwordMismatch = newPasswordConfirmation.length > 0 && newPassword !== newPasswordConfirmation;

        this.setState({
            oldPassword: oldPassword,
            newPassword: newPassword,
            newPasswordConfirmation: newPasswordConfirmation,
            errors: errors
        });

        window.componentChanged = true;

        return true;
    }


    closeEdit() {
        const { editingPassword } = this.state;
        if (editingPassword && this._isMounted) {
            this.setState({ editingPassword: false });
        }
        window.componentChanged = false;
    }

    toggleTooltip() {
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    render() {

        const { isLoggedIn, passwordUpdateResponse, passwordUpdateError, apiPasswordErrorMessage, passwordChangeIsWaiting } = this.props;
        let { oldPassword, newPassword, newPasswordConfirmation, errors, editingPassword } = this.state;
        const enablePasswordSave = errors.hasCapital &&
            errors.hasLower &&
            errors.hasSpecial &&
            errors.hasReqLength &&
            !errors.passwordConfirmationEmpty &&
            !errors.passwordEmpty &&
            !errors.passwordMismatch && oldPassword;
        const passwordHasErrors = errors.newPasswordEmpty || !errors.hasCapital ||
            !errors.hasLower ||
            !errors.hasSpecial ||
            !errors.hasReqLength;
        const confirmationHasError = errors.passwordMismatch;

        return (
            <div className="col-12 list-item-col not-linked">
                <div className="row  align-items-end">
                    <div className="col-12 col-sm-6 col-md-3">
                        <div className="list-item-col__label">Password</div>
                    </div>
                    <div className="col-12 col-sm-6 text-left text-sm-right text-md-left">
                        <div className="list-item-col__info">********</div>
                    </div>
                    <div className="col-12 col-md-3 text-sm-right">
                        {passwordChangeIsWaiting ? <MiniSpinner /> :
                            <div className="list-item-col__action">{/* Edit should change to Save and Cancel when clicked */}
                                {!editingPassword ? <button type="button" className="btn btn-link-style" onClick={() => this.toggleEdit()}>Edit</button> :
                                    <div className="list-item-col__action">
                                        <button type="button" className={"list-item-col__action--save btn btn-link-style" + (!enablePasswordSave ? " disabled-style" : "")} disabled={!enablePasswordSave} onClick={() => this.savePassword()}>Save</button>
                                        <button type="button" className="list-item-col__action--cancel btn btn-link-style" onClick={() => this.toggleEdit()}>Cancel</button>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>

                {/* Show this below the row above when user edits the password */}
                {editingPassword &&
                    <div className="row edit-mode">
                        <div className="col-12 col-lg-4 form-group">
                            <div className="il-group">
                                <GenericInput
                                    type="password"
                                    required
                                    name="OldPassword"
                                    placeholder="Old Password"
                                    value={oldPassword}
                                    autoFocus
                                    onChange={(e) => this.handlePasswordInputChange(e)}
                                    showEye
                                />
                            </div>
                    </div>
                    <div className={"col-12 col-sm-6 col-lg-4 form-group" + (!errors.passwordMismatch && !errors.passwordConfirmationEmpty ? " input-mismatch-password" : "")}>
                            <div className="il-group">
                                <GenericInput
                                    type="password"
                                    className={newPassword && passwordHasErrors ? " input-invalid" : ""}
                                    required
                                    name="NewPassword"
                                    value={newPassword}
                                    placeholder="New Password"
                                    autoComplete="new-password"
                                    onChange={(e) => this.handlePasswordInputChange(e)}
                                    showEye
                                />
                            </div>
                        </div>

                    <div className={"col-12 col-sm-6 col-lg-4 form-group" + (!errors.passwordMismatch && !errors.passwordConfirmationEmpty ? " input-mismatch-password" : "")}>
                            <div className={"il-group" + (newPasswordConfirmation ? " input-not-empty" : "") + (newPasswordConfirmation && errors.passwordMismatch ? " input-invalid" : "")}>
                                <GenericInput
                                    type="password"
                                    className={(confirmationHasError ? " input-invalid" : "")}
                                    required
                                    name="ConfirmPassword"
                                    value={newPasswordConfirmation}
                                    placeholder="Confirm New Password"
                                    autoComplete="new-password"
                                    onChange={(e) => this.handlePasswordInputChange(e)}
                                    showEye
                                />
                                <span className="password-matches">
                                    {!errors.passwordMismatch && !errors.passwordConfirmationEmpty && <>Password matches</>}
                                </span>
                            </div>
                        </div>
                        <div className="col-12">
                            {errors.passwordMismatch &&
                                <div className="error-msg">Password confirmation doesn’t match. </div>
                            }
                        </div>
                        <div className="col-12">
                            <ul id="password-validator">
                                <li id="lowercase-check" className={errors.hasLower ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">One lowercase character</div></li>
                                <li id="uppercase-check" className={errors.hasCapital ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">One uppercase character</div></li>
                                <li id="character-check" className={errors.hasSpecial ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">One number or special character</div></li>
                                <li id="length-check" className={errors.hasReqLength ? "check-valid" : ""}><div className="pw-icon"><span className="icon-check" /></div> <div className="pw-requirement">At least 8 characters long</div></li>
                            </ul>
                        </div>
                    </div>
                }

                <div className='row'>
                    {passwordUpdateResponse && <div className="col-12 success-msg">Your new password has been saved.</div>}
                    {apiPasswordErrorMessage && <SectionLoadingError message={apiPasswordErrorMessage} />}
                </div>
                <ConfirmationModal when={editingPassword && (oldPassword !== '' || newPassword !== '' || newPasswordConfirmation !== '')} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        userName: state.domain.un,
        passwordUpdateResponse: state.header.passwordUpdateResponse,
        passwordUpdateError: state.header.passwordUpdateError,
        apiPasswordErrorMessage: state.header.apiPasswordErrorMessage,
        email: state.domain.e,
        passwordChangeIsWaiting: state.header.passwordChangeIsWaiting
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changePassword: (Email, OldPassword, NewPassword, ConfirmPassword, successCallback, failureCallback) => {
            dispatch({
                type: types.CHANGE_PASSWORD,
                Email: Email,
                OldPassword: OldPassword,
                NewPassword: NewPassword,
                ConfirmPassword: ConfirmPassword,
                successCallback: successCallback,
                failureCallback: failureCallback
            });
        },
        clearPasswordChangeState: () => {
            dispatch({
                type: types.CHANGE_PASSWORD_CLEAR
            });
        }
    };
};




export default connect(mapStateToProps, mapDispatchToProps)(LoginSettingsUserName);